import type { GamePreset, PresetMetadata } from './types'

const metadata = [
  {
    id: 'mxdc',
    version: 14,
    gameVersion: '079',
    nameKey: 'presets.mxdc.name',
    descriptionKey: 'presets.mxdc.description',
    capabilities: {
      level: 'ocr',
      exp: 'fused',
      hp: 'fused',
      mp: 'fused',
      mesos: 'ocr',
      mapName: 'ocr',
      jobName: 'ocr',
    },
  },
  {
    id: 'artale', version: 1, gameVersion: 'Artale',
    nameKey: 'presets.artale.name', descriptionKey: 'presets.artale.description',
    capabilities: { level: 'ocr', exp: 'ocr', hp: 'ocr', mp: 'ocr', mesos: 'ocr', mapName: 'ocr', jobName: 'ocr' },
  },
  {
    id: 'gcw', version: 1, gameVersion: 'GCW',
    nameKey: 'presets.gcw.name', descriptionKey: 'presets.gcw.description',
    capabilities: { level: 'ocr', exp: 'ocr', hp: 'ocr', mp: 'ocr', mesos: 'ocr', mapName: 'ocr', jobName: 'ocr' },
  },
  {
    id: 'worlds', version: 1, gameVersion: 'MapleStory Worlds',
    nameKey: 'presets.worlds.name', descriptionKey: 'presets.worlds.description',
    capabilities: { level: 'ocr', exp: 'ocr', hp: 'ocr', mp: 'ocr', mesos: 'ocr', mapName: 'ocr', jobName: 'ocr' },
  },
] as const satisfies readonly PresetMetadata[]

const loaders: Readonly<Record<string, () => Promise<{ default: GamePreset }>>> = {
  worlds: () => import('./worlds'),
  mxdc: () => import('./mxdc'),
  artale: () => import('./artale'),
  gcw: () => import('./gcw'),
}

export class PresetRegistry {
  static list(): readonly PresetMetadata[] {
    return metadata
  }

  static async load(id: string): Promise<GamePreset> {
    const load = loaders[id]
    if (!load) throw new Error(`Unknown preset: ${id}`)
    return (await load()).default
  }
}
